var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarFilled = function SvgStarFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32454 21.9323C6.00728 22.135 5.60375 21.8525 5.68432 21.4842L7.12955 14.8766C7.16188 14.7288 7.11313 14.5749 7.00165 14.4729L2.13829 10.0218C1.86688 9.77342 2.01911 9.32015 2.38513 9.28683L8.76615 8.70594C8.92403 8.69157 9.06062 8.58988 9.11996 8.44254L11.6079 2.26514C11.7503 1.91162 12.2497 1.91162 12.392 2.26514L14.88 8.44254C14.9394 8.58988 15.076 8.69157 15.2338 8.70594L21.6149 9.28683C21.9809 9.32015 22.1331 9.77342 21.8617 10.0218L16.9983 14.4729C16.8869 14.5749 16.8381 14.7288 16.8704 14.8766L18.3157 21.4842C18.3962 21.8525 17.9927 22.135 17.6755 21.9323L12.2272 18.4517C12.0886 18.3632 11.9114 18.3632 11.7728 18.4517L6.32454 21.9323Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star-filled.10247870fe9150015befe5a4339431f2.svg";